import request from "@/utils/requestRoad";
import requestTest from "@/utils/requestTest";

// 获取路侧订单信息
export const getRoadOrder = data => {
  return request({
    url: "/payment/roadSide/list",
    method: "POST",
    data
  });
};

// // 获取车场是否支持路侧追缴'
// export const getParkingRoad = data => {
//   return request({
//     url: "/payment/roadSide/" + data.parkId,
//     method: "GET"
//   });
// };

// 获取车场是否支持路侧追缴
export const getParkingRoad = data => {
  return request({
    url: "/payment/roadSide/" + data.parkId,
    method: "GET"
  });
};
